/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * An enumeration.
 */
export enum SampleRequestSupportRequestType {
  SPEAK_TO_SALES_REP = "speak_to_sales_rep",
  SPEAK_TO_TECHNICAL_STAFF = "speak_to_technical_staff",
  PRICE_QUOTE = "price_quote",
  DOCUMENTATION_TECHNICAL_INFORMATION = "documentation_technical_information",
  PROJECT_TOO_NEW = "project_too_new",
}
